"use strict";
var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
import $ from "jquery";
import _ from "underscore";
export default class PartialFetcher {
  constructor(store, bulkFetcher, storeUpdater) {
    __publicField(this, "bulkFetcher");
    __publicField(this, "store");
    __publicField(this, "storeUpdater");
    this.store = store;
    this.bulkFetcher = bulkFetcher;
    this.storeUpdater = storeUpdater;
  }
  fetchItemIfNeeded(id) {
    return this.fetchItemsIfNeeded([id]).then(_.first);
  }
  fetchItemsIfNeeded(ids, validator = null) {
    var loader = $.Deferred();
    var toFetch = [];
    var result = [];
    _.each(ids, (id) => {
      var existing = this.store.find(id);
      if (!existing || validator && !validator(existing)) {
        toFetch.push(id);
      } else {
        result.push(existing);
      }
    });
    if (toFetch.length > 0) {
      this.bulkFetcher(toFetch).then((items) => {
        if (this.storeUpdater) {
          this.storeUpdater(items);
        } else {
          this.store.addOrUpdateAll(items);
        }
        result = _.map(ids, (id) => {
          return this.store.find(id);
        });
        loader.resolve(result);
      });
    } else {
      loader.resolve(result);
    }
    return loader.promise();
  }
}
